import React, { useContext, useEffect, useState } from "react";
import { CommonModal, H6 } from "../../AbstractElements";
import { Row, Col, Form, FormGroup, Label, Input, InputGroup, Table } from "reactstrap";
import Select from "react-select";
import { useForm, useController } from "react-hook-form";
import { getCarTypes, showAlert, getUserDetails } from "../../Services/Shared.service";
import DatePicker from "react-datepicker";
import { ArrowDown, ArrowUp, PlusSquare, Trash2 } from "react-feather";
import { createCar, getCarDetail, getCarDocuments, getFuelTypes, updateCar, uploadCarDocuments } from "../../Services/Car.service";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import { getParentCompany } from "../../Services/Ventor.service";

const CreateCar = ({
    Large,
    title,
    LargeModaltoggle,
    cityDataList,
    setShowApiLoader,
    editId
}) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        reset,
        trigger,
        clearErrors,
        getValues
    } = useForm({
        defaultValues: {
            carNo: "",
            isSapData: false,
            sapId: "",
            registrationNo: "",
            isAc: true,
            purchasedOn: "",
            purchasedFrom: "",
            expectedMileage: "",
            isOutstation: false,
            color: "",
            engineNo: "",
            chasisNo: "",
            model: "",
            totalCost: "",
            permitNo: "",
            permitExpDate: "",
            toShowAllIndiaPermit: false,
            toShowCCPermit: false,
            toShowPUCPermit: false,
            allIndiaPermitNo: "",
            allIndiaPermitExpDate: "",
            ccPermitNo: "",
            ccPermitExpDate: "",
            pucPermitNo: "",
            pucPermitExpDate: "",
            rc: "",
            fitnessPermitNo: "",
            fitnessPermitExpDate: "",
            isOldUnit: false,
            roadTaxPermitNo: "",
            roadTaxPermitExpDate: "",
            emission: "",
            emissionExpDate: "",
            meterPassing: "",
            meterPassingExpDate: "",
            isInsured: false,
            insuranceNumber: "",
            insuranceAmt: "",
            insuranceStartDate: "",
            insuranceEndDate: "",
            insuranceCompany: "",
            insuranceContactNo: "",
            serviceCity: "",
            aggregatorDropdown: "",
            carTypeDropdown: "",
            isAvailable: true,
            fuelTypeDropdown: "",
            isEv: false,
            carId: "",
            procurementStatus: ""
        }
    });

    console.log("values", getValues())

    const aggregatorField = useController({
        name: "aggregatorDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Aggregator is Required",
            },
        },
    }).field;

    const [carTypeData, setCarTypeData] = useState([]);
    const [aggregatorList, setAggregatorList] = useState([]);
    const [fuelTypes, setFuelTypes] = useState([]);
    const [evFuelTypes, setEvFuelTypes] = useState([]);
    const [isAdvanced, setIsAdvanced] = useState(false);
    const [tabName, setTabName] = useState("Basic Information")
    const [carDetail, setCarDetail] = useState({})
    const [files, setFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const {mix_background_layout} = useContext(CustomizerContext)

    const procurementData = [
        { value: "offRoad", label: "offRoad" },
        { value: "onRoad", label: "onRoad" }
    ]

    useEffect(() => {
        getParentCompany().then((result) => {
            if (result.data) {
                const data = result.data.filter((element) => element.isDeleted === false).map((element) => {
                    return {
                        label: element.companyName,
                        value: element,
                    };
                });
                setAggregatorList(data);
            }
        });
        getFuelTypes().then((result) => {
            if (result.data) {
                const data = result.data.map((element) => {
                    return {
                        label: element.name,
                        value: element,
                    };
                });
                setFuelTypes(data.filter((f) => f.label !== "ELECTRIC"))
                setEvFuelTypes(data.filter((f) => f.label === "ELECTRIC"))
            }
        });
    }, []);

    const serviceCityField = useController({
        name: "serviceCity",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    const purchasedOnField = useController({
        name: "purchasedOn",
        control,
        rules: {
            required: {
                value: true,
                message: "Purchased On is Required",
            },
        },
    }).field;

    const permitExpDateField = useController({
        name: "permitExpDate",
        control,
        rules: {},
    }).field;

    const allIndiaPermitExpDateField = useController({
        name: "allIndiaPermitExpDate",
        control,
        rules: {},
    }).field;

    const ccPermitExpDateField = useController({
        name: "ccPermitExpDate",
        control,
        rules: {},
    }).field;

    const pucPermitExpDateField = useController({
        name: "pucPermitExpDate",
        control,
        rules: {},
    }).field;

    const fitnessPermitExpDateField = useController({
        name: "fitnessPermitExpDate",
        control,
        rules: {},
    }).field;

    const roadTaxPermitExpDateField = useController({
        name: "roadTaxPermitExpDate",
        control,
        rules: {},
    }).field;

    const emissionExpDateField = useController({
        name: "emissionExpDate",
        control,
        rules: {},
    }).field;

    const meterPassingExpDateField = useController({
        name: "meterPassingExpDate",
        control,
        rules: {},
    }).field;


    const isSapDataField = useController({
        name: "isSapData",
        control,
        rules: {},
    }).field;

    const isAcField = useController({
        name: "isAc",
        control,
        rules: {},
    }).field;

    const isOutstationField = useController({
        name: "isOutstation",
        control,
        rules: {},
    }).field;

    const toShowAllIndiaPermitField = useController({
        name: "toShowAllIndiaPermit",
        control,
        rules: {},
    }).field;

    const toShowCCPermitField = useController({
        name: "toShowCCPermit",
        control,
        rules: {},
    }).field;

    const toShowPUCPermitField = useController({
        name: "toShowPUCPermit",
        control,
        rules: {},
    }).field;

    const isOldUnitField = useController({
        name: "isOldUnit",
        control,
        rules: {},
    }).field;

    const isInsuredField = useController({
        name: "isInsured",
        control,
        rules: {},
    }).field;

    const isAvailableField = useController({
        name: "isAvailable",
        control,
        rules: {},
    }).field;

    const isEVField = useController({
        name: "isEv",
        control,
        rules: {},
    }).field;


    const carTypeField = useController({
        name: "carTypeDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Car type is Required",
            },
        },
    }).field;

    const fuelTypeDropdownField = useController({
        name: "fuelTypeDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Fuel type is Required",
            },
        },
    }).field;

    const insuranceStartDateField = useController({
        name: "insuranceStartDate",
        control,
        rules: {},
    }).field;

    const insuranceEndDateField = useController({
        name: "insuranceEndDate",
        control,
        rules: {},
    }).field;

    const procurementStatusField = useController({
        name: "procurementStatus",
        control,
        rules: {
            required: {
                value: true,
                message: "Procurument Status is Required",
            },
        },
    }).field;

    const cityData = cityDataList ? cityDataList : [];

    useEffect(() => {
        const serviceCityId = serviceCityField.value?.id;
        if (!serviceCityId) {
            setCarTypeData([]);
            return;
        }
        let obj = {
            serviceCityId,
        };
        getCarTypes(obj)
            .then((result) => {
                const data = result.data.map((element) => {
                    return {
                        label: element.name,
                        value: element,
                    };
                });
                setCarTypeData(data);
            })
            .catch((err) => {
                showAlert("error", "Unable to fetch Car details for selected City");
            });
    }, [serviceCityField.value]);

    useEffect(() => {
        console.log("inside useeffect edit id", editId)
        if (editId) {
            getParentCompany().then((result) => {
                if (result.data) {
                    const data = result.data.filter((element) => element.isDeleted === false).map((element) => {
                        return {
                            label: element.companyName,
                            value: element,
                        };
                    });
                    setAggregatorList(data);
                }
            });
            getFuelTypes().then((result) => {
                if (result.data) {
                    const data = result.data.map((element) => {
                        return {
                            label: element.name,
                            value: element,
                        };
                    });
                    setFuelTypes(data);
                }
            });
            getCarDetail(editId)
                .then((result) => {
                    if (result.data) {
                        setCarDetail(result.data)
                        reset({
                            carNo: result.data?.carNo ? result.data.carNo : "",
                            isSapData: result.data?.isSapData ? true : false,
                            sapId: result.data?.sapId ? result.data.sapId : "",
                            registrationNo: result.data?.registrationNo ? result.data.registrationNo : "",
                            isAc: result.data?.isAc ? true : false,
                            purchasedOn: result.data?.purchasedOn ? new Date(result.data.purchasedOn) : "",
                            purchasedFrom: result.data?.purchasedFrom ? result.data.purchasedFrom : "",
                            expectedMileage: result.data?.expectedMileage ? result.data.expectedMileage.toString() : "",
                            isOutstation: result.data?.isOutstation ? true : false,
                            color: result.data?.color ? result.data.color : "",
                            engineNo: result.data?.engineNo ? result.data.engineNo : "",
                            chasisNo: result.data?.chasisNo ? result.data.chasisNo : "",
                            model: result.data?.model ? result.data.model : "",
                            totalCost: result.data?.totalCost ? result.data.totalCost.toString() : "",
                            permitNo: result.data?.permitNo ? result.data.permitNo : "",
                            permitExpDate: result.data?.permitExpDate ? new Date(result.data.permitExpDate) : "",
                            toShowAllIndiaPermit: result.data?.allIndiaPermitNo || result.data?.allIndiaPermitExpDate ? true : false,
                            toShowCCPermit: result.data?.ccPermitNo || result.data?.ccPermitExpDate ? true : false,
                            toShowPUCPermit: result.data?.pucPermitNo || result.data?.pucPermitExpDate ? true : false,
                            allIndiaPermitNo: result.data?.allIndiaPermitNo ? result.data.allIndiaPermitNo : "",
                            allIndiaPermitExpDate: result.data?.allIndiaPermitExpDate ? new Date(result.data.allIndiaPermitExpDate) : "",
                            ccPermitNo: result.data?.ccPermitNo ? result.data.ccPermitNo : "",
                            ccPermitExpDate: result.data?.ccPermitExpDate ? new Date(result.data.ccPermitExpDate) : "",
                            pucPermitNo: result.data?.pucPermitNo ? result.data.pucPermitNo : "",
                            pucPermitExpDate: result.data?.pucPermitExpDate ? new Date(result.data.pucPermitExpDate) : "",
                            rc: result.data?.rc ? result.data.rc : "",
                            fitnessPermitNo: result.data?.fitnessPermitNo ? result.data.fitnessPermitNo : "",
                            fitnessPermitExpDate: result.data?.fitnessPermitExpDate ? new Date(result.data.fitnessPermitExpDate) : "",
                            isOldUnit: result.data?.isOldUnit ? true : false,
                            roadTaxPermitNo: result.data?.roadTaxPermitNo ? result.data.roadTaxPermitNo : "",
                            roadTaxPermitExpDate: result.data?.roadTaxPermitExpDate ? new Date(result.data.roadTaxPermitExpDate) : "",
                            emission: result.data?.emission ? result.data.emission : "",
                            emissionExpDate: result.data?.emissionExpDate ? new Date(result.data.emissionExpDate) : "",
                            meterPassing: result.data?.meterPassing ? result.data.meterPassing : "",
                            meterPassingExpDate: result.data?.meterPassingExpDate ? new Date(result.data.meterPassingExpDate) : "",
                            isInsured: result.data?.isInsured ? true : false,
                            insuranceNumber: result.data?.insuranceNumber ? result.data.insuranceNumber : "",
                            insuranceAmt: result.data?.insuranceAmt ? result.data.insuranceAmt.toString() : "",
                            insuranceStartDate: result.data?.insuranceStartDate ? new Date(result.data.insuranceStartDate) : "",
                            insuranceEndDate: result.data?.insuranceEndDate ? new Date(result.data.insuranceEndDate) : "",
                            insuranceCompany: result.data?.insuranceCompany ? result.data.insuranceCompany : "",
                            insuranceContactNo: result.data?.insuranceContactNo ? result.data.insuranceContactNo : "",
                            serviceCity: result.data?.serviceCityId ? { id: result.data.serviceCityId } : "",
                            aggregatorDropdown: result.data?.aggregatorId ? { id: result.data.aggregatorId } : "",
                            carTypeDropdown: result.data?.carTypeId ? { id: result.data.carTypeId } : "",
                            isAvailable: result.data?.isAvailable ? true : false,
                            fuelTypeDropdown: result.data?.fuelTypeId ? { id: result.data.fuelTypeId } : "",
                            isEv: result.data?.isEv ? true : false,
                            carId: result.data?.carId ? result.data.carId.toString() : "",
                            procurementStatus: result.data?.procurementStatus ? result.data.procurementStatus : "",
                            primaryDriverId: result.data?.primaryDriverId ? result.data.primaryDriverId.toString() : "",
                        })
                    }
                    getCarDocuments(result.data.carNo).then((result) => {
                        setUploadedFiles(result.data)
                    }).catch((err) => {
                        showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                    });
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                });
        }
    }, [editId])

    const onFormSubmit = () => {
        const values = getValues()
        console.log("form values", values);
        setShowApiLoader(true);
        if (editId) {
            const body = {
                id: editId,
                carNo: values.carNo ? values.carNo : null,
                isSapData: values.isSapData ? true : false,
                sapId: values.sapId ? values.sapId : null,
                registrationNo: values.registrationNo ? values.registrationNo : null,
                isAc: values.isAc ? true : false,
                purchasedOn: values.purchasedOn ? new Date(values.purchasedOn) : null,
                purchasedFrom: values.purchasedFrom ? values.purchasedFrom : null,
                expectedMileage: values.expectedMileage ? Number(values.expectedMileage) : null,
                isOutstation: values.isOutstation ? true : false,
                color: values.color ? values.color : null,
                engineNo: values.engineNo ? values.engineNo : null,
                chasisNo: values.chasisNo ? values.chasisNo : null,
                model: values.model ? values.model : null,
                totalCost: values.totalCost ? Number(values.totalCost) : null,
                permitNo: values.permitNo ? values.permitNo : null,
                permitExpDate: values.permitExpDate ? new Date(values.permitExpDate) : null,
                allIndiaPermitNo: values.allIndiaPermitNo ? values.allIndiaPermitNo : null,
                allIndiaPermitExpDate: values.allIndiaPermitExpDate ? new Date(values.allIndiaPermitExpDate) : null,
                ccPermitNo: values.ccPermitNo ? values.ccPermitNo : null,
                ccPermitExpDate: values.ccPermitExpDate ? new Date(values.ccPermitExpDate) : null,
                pucPermitNo: values.pucPermitNo ? values.pucPermitNo : null,
                pucPermitExpDate: values.pucPermitExpDate ? new Date(values.pucPermitExpDate) : null,
                rc: values.rc ? values.rc : null,
                fitnessPermitNo: values.fitnessPermitNo ? values.fitnessPermitNo : null,
                fitnessPermitExpDate: values.fitnessPermitExpDate ? new Date(values.fitnessPermitExpDate) : null,
                isOldUnit: values.isOldUnit ? true : false,
                roadTaxPermitNo: values.roadTaxPermitNo ? values.roadTaxPermitNo : null,
                roadTaxPermitExpDate: values.roadTaxPermitExpDate ? new Date(values.roadTaxPermitExpDate) : null,
                emission: values.emission ? values.emission : null,
                emissionExpDate: values.emissionExpDate ? new Date(values.emissionExpDate) : null,
                meterPassing: values.meterPassing ? values.meterPassing : null,
                meterPassingExpDate: values.meterPassingExpDate ? new Date(values.meterPassingExpDate) : null,
                isInsured: values.isInsured ? true : false,
                insuranceNumber: values.insuranceNumber ? values.insuranceNumber : null,
                insuranceAmt: values.insuranceAmt ? Number(values.insuranceAmt) : null,
                insuranceStartDate: values.insuranceStartDate ? new Date(values.insuranceStartDate) : null,
                insuranceEndDate: values.insuranceEndDate ? new Date(values.insuranceEndDate) : null,
                insuranceCompany: values.insuranceCompany ? values.insuranceCompany : null,
                insuranceContactNo: values.insuranceContactNo ? values.insuranceContactNo : null,
                createdOn: carDetail.createdOn ? carDetail.createdOn : null,
                createdById: carDetail.createdById ? carDetail.createdById : null,
                deletedOn: carDetail.deletedOn ? carDetail.deletedOn : null,
                deletedById: carDetail.deletedById ? carDetail.deletedById : null,
                isDeleted: carDetail.isDeleted ? true : false,
                serviceCityId: values.serviceCity?.id ? values.serviceCity.id : null,
                aggregatorId: values.aggregatorDropdown?.id ? values.aggregatorDropdown.id : null,
                carTypeId: values.carTypeDropdown?.id ? values.carTypeDropdown.id : null,
                isAvailable: values.isAvailable ? true : false,
                fuelTypeId: values.fuelTypeDropdown?.id ? values.fuelTypeDropdown.id : null,
                fuelTypeName: values.fuelTypeDropdown?.name ? values.fuelTypeDropdown.name : null,
                isEv: values.isEv ? true : false,
                carId: values.carId ? Number(values.carId) : null,
                procurementStatus: values.procurementStatus ? values.procurementStatus : null,
                primaryDriverId: values.primaryDriverId ? Number(values.primaryDriverId) : null,
            };
            if(carDetail.carId != values.carId){
                body["newCarId"] = values.carId ? Number(values.carId) : null
                body["carId"] = carDetail.carId ? Number(carDetail.carId) : null
            }
            updateCar(body)
                .then((result) => {
                    if (files.length > 0) {
                        const data = new FormData();
                        data.append("carNo", result.data.carNo);
                        [...files].map((f) => {
                            data.append("files", f)
                        })
                        uploadCarDocuments(data).then((result) => {
                            setShowApiLoader(false);
                            showAlert("success", "Car Updated Successfully");
                            reset({
                                carNo: "",
                                isSapData: false,
                                sapId: "",
                                registrationNo: "",
                                isAc: true,
                                purchasedOn: "",
                                purchasedFrom: "",
                                expectedMileage: "",
                                isOutstation: false,
                                color: "",
                                engineNo: "",
                                chasisNo: "",
                                model: "",
                                totalCost: "",
                                permitNo: "",
                                permitExpDate: "",
                                toShowAllIndiaPermit: false,
                                toShowCCPermit: false,
                                toShowPUCPermit: false,
                                allIndiaPermitNo: "",
                                allIndiaPermitExpDate: "",
                                ccPermitNo: "",
                                ccPermitExpDate: "",
                                pucPermitNo: "",
                                pucPermitExpDate: "",
                                rc: "",
                                fitnessPermitNo: "",
                                fitnessPermitExpDate: "",
                                isOldUnit: false,
                                roadTaxPermitNo: "",
                                roadTaxPermitExpDate: "",
                                emission: "",
                                emissionExpDate: "",
                                meterPassing: "",
                                meterPassingExpDate: "",
                                isInsured: false,
                                insuranceNumber: "",
                                insuranceAmt: "",
                                insuranceStartDate: "",
                                insuranceEndDate: "",
                                insuranceCompany: "",
                                insuranceContactNo: "",
                                serviceCity: "",
                                aggregatorDropdown: "",
                                carTypeDropdown: "",
                                isAvailable: true,
                                fuelTypeDropdown: "",
                                isEv: false,
                                carId: "",
                                procurementStatus: ""
                            })
                            setIsAdvanced(false)
                            setTabName("Basic Information")
                            LargeModaltoggle();
                            setFiles([]);
                        }).catch((err) => {
                            setShowApiLoader(false);
                            showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                        });

                    } else {
                        setShowApiLoader(false);
                        showAlert("success", "Car Updated Successfully");
                        reset({
                            carNo: "",
                            isSapData: false,
                            sapId: "",
                            registrationNo: "",
                            isAc: true,
                            purchasedOn: "",
                            purchasedFrom: "",
                            expectedMileage: "",
                            isOutstation: false,
                            color: "",
                            engineNo: "",
                            chasisNo: "",
                            model: "",
                            totalCost: "",
                            permitNo: "",
                            permitExpDate: "",
                            toShowAllIndiaPermit: false,
                            toShowCCPermit: false,
                            toShowPUCPermit: false,
                            allIndiaPermitNo: "",
                            allIndiaPermitExpDate: "",
                            ccPermitNo: "",
                            ccPermitExpDate: "",
                            pucPermitNo: "",
                            pucPermitExpDate: "",
                            rc: "",
                            fitnessPermitNo: "",
                            fitnessPermitExpDate: "",
                            isOldUnit: false,
                            roadTaxPermitNo: "",
                            roadTaxPermitExpDate: "",
                            emission: "",
                            emissionExpDate: "",
                            meterPassing: "",
                            meterPassingExpDate: "",
                            isInsured: false,
                            insuranceNumber: "",
                            insuranceAmt: "",
                            insuranceStartDate: "",
                            insuranceEndDate: "",
                            insuranceCompany: "",
                            insuranceContactNo: "",
                            serviceCity: "",
                            aggregatorDropdown: "",
                            carTypeDropdown: "",
                            isAvailable: true,
                            fuelTypeDropdown: "",
                            isEv: false,
                            carId: "",
                            procurementStatus: ""
                        })
                        setIsAdvanced(false)
                        setTabName("Basic Information")
                        LargeModaltoggle();
                        setFiles([]);
                    }
                })
                .catch((err) => {
                    setShowApiLoader(false);
                    showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                });
        } else {
            const body = {
                carNo: values.carNo ? values.carNo : null,
                isSapData: values.isSapData ? true : false,
                sapId: values.sapId ? values.sapId : null,
                registrationNo: values.registrationNo ? values.registrationNo : null,
                isAc: values.isAc ? true : false,
                purchasedOn: values.purchasedOn ? new Date(values.purchasedOn) : null,
                purchasedFrom: values.purchasedFrom ? values.purchasedFrom : null,
                expectedMileage: values.expectedMileage ? Number(values.expectedMileage) : null,
                isOutstation: values.isOutstation ? true : false,
                color: values.color ? values.color : null,
                engineNo: values.engineNo ? values.engineNo : null,
                chasisNo: values.chasisNo ? values.chasisNo : null,
                model: values.model ? values.model : null,
                totalCost: values.totalCost ? Number(values.totalCost) : null,
                permitNo: values.permitNo ? values.permitNo : null,
                permitExpDate: values.permitExpDate ? new Date(values.permitExpDate) : null,
                allIndiaPermitNo: values.allIndiaPermitNo ? values.allIndiaPermitNo : null,
                allIndiaPermitExpDate: values.allIndiaPermitExpDate ? new Date(values.allIndiaPermitExpDate) : null,
                ccPermitNo: values.ccPermitNo ? values.ccPermitNo : null,
                ccPermitExpDate: values.ccPermitExpDate ? new Date(values.ccPermitExpDate) : null,
                pucPermitNo: values.pucPermitNo ? values.pucPermitNo : null,
                pucPermitExpDate: values.pucPermitExpDate ? new Date(values.pucPermitExpDate) : null,
                rc: values.rc ? values.rc : null,
                fitnessPermitNo: values.fitnessPermitNo ? values.fitnessPermitNo : null,
                fitnessPermitExpDate: values.fitnessPermitExpDate ? new Date(values.fitnessPermitExpDate) : null,
                isOldUnit: values.isOldUnit ? true : false,
                roadTaxPermitNo: values.roadTaxPermitNo ? values.roadTaxPermitNo : null,
                roadTaxPermitExpDate: values.roadTaxPermitExpDate ? new Date(values.roadTaxPermitExpDate) : null,
                emission: values.emission ? values.emission : null,
                emissionExpDate: values.emissionExpDate ? new Date(values.emissionExpDate) : null,
                meterPassing: values.meterPassing ? values.meterPassing : null,
                meterPassingExpDate: values.meterPassingExpDate ? new Date(values.meterPassingExpDate) : null,
                isInsured: values.isInsured ? true : false,
                insuranceNumber: values.insuranceNumber ? values.insuranceNumber : null,
                insuranceAmt: values.insuranceAmt ? Number(values.insuranceAmt) : null,
                insuranceStartDate: values.insuranceStartDate ? new Date(values.insuranceStartDate) : null,
                insuranceEndDate: values.insuranceEndDate ? new Date(values.insuranceEndDate) : null,
                insuranceCompany: values.insuranceCompany ? values.insuranceCompany : null,
                insuranceContactNo: values.insuranceContactNo ? values.insuranceContactNo : null,
                createdOn: null,
                createdById: null,
                deletedOn: null,
                deletedById: null,
                isDeleted: false,
                serviceCityId: values.serviceCity?.id ? values.serviceCity.id : null,
                aggregatorId: values.aggregatorDropdown?.id ? values.aggregatorDropdown.id : null,
                carTypeId: values.carTypeDropdown?.id ? values.carTypeDropdown.id : null,
                isAvailable: values.isAvailable ? true : false,
                fuelTypeId: values.fuelTypeDropdown?.id ? values.fuelTypeDropdown.id : null,
                fuelTypeName: values.fuelTypeDropdown?.name ? values.fuelTypeDropdown.name : null,
                isEv: values.isEv ? true : false,
                carId: values.carId ? Number(values.carId) : null,
                procurementStatus: values.procurementStatus ? values.procurementStatus : null,
            };
            createCar(body)
                .then((result) => {
                    if (files.length > 0) {
                        const data = new FormData();
                        data.append("carNo", result.data.carNo);
                        [...files].map((f) => {
                            data.append("files", f)
                        })
                        uploadCarDocuments(data).then((result) => {
                            setShowApiLoader(false);
                            showAlert("success", "Car Created Successfully");
                            reset({
                                carNo: "",
                                isSapData: false,
                                sapId: "",
                                registrationNo: "",
                                isAc: true,
                                purchasedOn: "",
                                purchasedFrom: "",
                                expectedMileage: "",
                                isOutstation: false,
                                color: "",
                                engineNo: "",
                                chasisNo: "",
                                model: "",
                                totalCost: "",
                                permitNo: "",
                                permitExpDate: "",
                                toShowAllIndiaPermit: false,
                                toShowCCPermit: false,
                                toShowPUCPermit: false,
                                allIndiaPermitNo: "",
                                allIndiaPermitExpDate: "",
                                ccPermitNo: "",
                                ccPermitExpDate: "",
                                pucPermitNo: "",
                                pucPermitExpDate: "",
                                rc: "",
                                fitnessPermitNo: "",
                                fitnessPermitExpDate: "",
                                isOldUnit: false,
                                roadTaxPermitNo: "",
                                roadTaxPermitExpDate: "",
                                emission: "",
                                emissionExpDate: "",
                                meterPassing: "",
                                meterPassingExpDate: "",
                                isInsured: false,
                                insuranceNumber: "",
                                insuranceAmt: "",
                                insuranceStartDate: "",
                                insuranceEndDate: "",
                                insuranceCompany: "",
                                insuranceContactNo: "",
                                serviceCity: "",
                                aggregatorDropdown: "",
                                carTypeDropdown: "",
                                isAvailable: true,
                                fuelTypeDropdown: "",
                                isEv: false,
                                carId: "",
                                procurementStatus: ""
                            })
                            setIsAdvanced(false)
                            setTabName("Basic Information")
                            LargeModaltoggle();
                            setFiles([]);
                        }).catch((err) => {
                            setShowApiLoader(false);
                            showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                        });

                    } else {
                        setShowApiLoader(false);
                        showAlert("success", "Car Created Successfully");
                        reset({
                            carNo: "",
                            isSapData: false,
                            sapId: "",
                            registrationNo: "",
                            isAc: true,
                            purchasedOn: "",
                            purchasedFrom: "",
                            expectedMileage: "",
                            isOutstation: false,
                            color: "",
                            engineNo: "",
                            chasisNo: "",
                            model: "",
                            totalCost: "",
                            permitNo: "",
                            permitExpDate: "",
                            toShowAllIndiaPermit: false,
                            toShowCCPermit: false,
                            toShowPUCPermit: false,
                            allIndiaPermitNo: "",
                            allIndiaPermitExpDate: "",
                            ccPermitNo: "",
                            ccPermitExpDate: "",
                            pucPermitNo: "",
                            pucPermitExpDate: "",
                            rc: "",
                            fitnessPermitNo: "",
                            fitnessPermitExpDate: "",
                            isOldUnit: false,
                            roadTaxPermitNo: "",
                            roadTaxPermitExpDate: "",
                            emission: "",
                            emissionExpDate: "",
                            meterPassing: "",
                            meterPassingExpDate: "",
                            isInsured: false,
                            insuranceNumber: "",
                            insuranceAmt: "",
                            insuranceStartDate: "",
                            insuranceEndDate: "",
                            insuranceCompany: "",
                            insuranceContactNo: "",
                            serviceCity: "",
                            aggregatorDropdown: "",
                            carTypeDropdown: "",
                            isAvailable: true,
                            fuelTypeDropdown: "",
                            isEv: false,
                            carId: "",
                            procurementStatus: ""
                        })
                        setIsAdvanced(false)
                        setTabName("Basic Information")
                        LargeModaltoggle();
                        setFiles([]);
                    }

                })
                .catch((err) => {
                    setShowApiLoader(false);
                    showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                });
        }
    }

    const handleAggregatorSelect = (data) => {
        aggregatorField.onChange(data.value);
    };

    const handleCitySelectChange = (data) => {
        serviceCityField.onChange(data.value);
    };

    const handleCarTypeSelectChange = (data) => {
        carTypeField.onChange(data.value);
        if (data.value?.id == 101) {
            isEVField.onChange(true)
            fuelTypeDropdownField.onChange("")
        } else {
            isEVField.onChange(false)
            fuelTypeDropdownField.onChange("")
        }
    };

    const handleFuelTypeSelectChange = (data) => {
        fuelTypeDropdownField.onChange(data.value);
    };

    const getFile = () => {
        document.getElementById('upfile').click();
    };
    const onFileChange = event => {
        console.log("event files", event.target.files)
        setFiles([...files, ...event.target.files])
    };

    const deleteFile = (index) => {
        setFiles([...files].filter((f, i) => i != index))
    }

    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={() => {
                reset({
                    carNo: "",
                    isSapData: false,
                    sapId: "",
                    registrationNo: "",
                    isAc: true,
                    purchasedOn: "",
                    purchasedFrom: "",
                    expectedMileage: "",
                    isOutstation: false,
                    color: "",
                    engineNo: "",
                    chasisNo: "",
                    model: "",
                    totalCost: "",
                    permitNo: "",
                    permitExpDate: "",
                    toShowAllIndiaPermit: false,
                    toShowCCPermit: false,
                    toShowPUCPermit: false,
                    allIndiaPermitNo: "",
                    allIndiaPermitExpDate: "",
                    ccPermitNo: "",
                    ccPermitExpDate: "",
                    pucPermitNo: "",
                    pucPermitExpDate: "",
                    rc: "",
                    fitnessPermitNo: "",
                    fitnessPermitExpDate: "",
                    isOldUnit: false,
                    roadTaxPermitNo: "",
                    roadTaxPermitExpDate: "",
                    emission: "",
                    emissionExpDate: "",
                    meterPassing: "",
                    meterPassingExpDate: "",
                    isInsured: false,
                    insuranceNumber: "",
                    insuranceAmt: "",
                    insuranceStartDate: "",
                    insuranceEndDate: "",
                    insuranceCompany: "",
                    insuranceContactNo: "",
                    serviceCity: "",
                    aggregatorDropdown: "",
                    carTypeDropdown: "",
                    isAvailable: true,
                    fuelTypeDropdown: "",
                    isEv: false,
                    carId: "",
                    procurementStatus: ""
                })
                setIsAdvanced(false)
                setTabName("Basic Information")
                LargeModaltoggle();
            }}
            size="xl"
        >
            <Form className="create-driver">
                {tabName == "Basic Information" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Basic Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Cab No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("carNo", {
                                        required: {
                                            value: true,
                                            message: "Cab No is required",
                                        },
                                        onChange: (e) => {
                                            setValue("carNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.carNo?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Cab Id</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("carId", {
                                        required: {
                                            value: true,
                                            message: "Cab Id is required",
                                        },
                                        onChange: (e) => {
                                            setValue("carId", e.target.value.replace(/[^0-9]/g, ''))
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>{errors?.carId?.message}</span>
                            </Col>
                        </FormGroup>

                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Registration No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("registrationNo", {
                                        required: {
                                            value: true,
                                            message: "Registration No is required",
                                        },
                                        onChange: (e) => {
                                            setValue("registrationNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.registrationNo?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isAc" type="checkbox" checked={isAcField.value}
                                    onChange={(value) => isAcField.onChange(value)} />
                                <Label className="mb-0" for="isAc">Is Ac</Label>
                            </div>
                        </FormGroup>

                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Engine No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("engineNo", {
                                        onChange: (e) => {
                                            setValue("engineNo", e.target.value.trimStart())
                                        },
                                        required: {
                                            value: true,
                                            message: "Engine No is required",
                                        },
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.engineNo?.message}
                                </span>
                            </Col>

                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Chasis No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("chasisNo", {
                                        onChange: (e) => {
                                            setValue("chasisNo", e.target.value.trimStart())
                                        },
                                        required: {
                                            value: true,
                                            message: "Chasis No is required",
                                        },
                                    })}
                                    type="text"
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.chasisNo?.message}
                                </span>
                            </Col>
                        </FormGroup>
                    </Row>
                    <Row>
                        <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
                    </Row>
                    {isAdvanced ? <Row>
                        <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isSapData" type="checkbox" checked={isSapDataField.value}
                                    onChange={(value) => isSapDataField.onChange(value)} />
                                <Label className="mb-0" for="isSapData">Is Sap Data</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Sap Id</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("sapId", {
                                        onChange: (e) => {
                                            setValue("sapId", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Purchased On</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={purchasedOnField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => purchasedOnField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                                <span style={{ color: "red" }}>
                                    {errors?.purchasedOn?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Purchased From</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("purchasedFrom", {
                                        onChange: (e) => {
                                            setValue("purchasedFrom", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>

                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Expected Mileage</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    pattern="[0-9.]+"
                                    {...register("expectedMileage", {
                                        onChange: (e) => {
                                            setValue("expectedMileage", e.target.value.replace(/[^0-9.]/g, ''))
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isOutstation" type="checkbox" checked={isOutstationField.value}
                                    onChange={(value) => isOutstationField.onChange(value)} />
                                <Label className="mb-0" for="isOutstation">Is Outstation</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Color</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("color", {
                                        onChange: (e) => {
                                            setValue("color", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Model</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("model", {
                                        onChange: (e) => {
                                            setValue("model", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Total Cost</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    pattern="[0-9.]+"
                                    {...register("totalCost", {
                                        onChange: (e) => {
                                            setValue("totalCost", e.target.value.replace(/[^0-9.]/g, ''))
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                    </Row> : null}
                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={async () => {
                            const result = await trigger(["carNo", "registrationNo", "engineNo", "chasisNo"]);
                            if (result) {
                                setTabName("Cab Information");
                                setIsAdvanced(false)
                                clearErrors()
                            }
                        }}>
                            Next
                        </button>
                    </Row>
                </> : tabName == "Cab Information" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Cab Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Aggregator</Label>
                            <Col className="col-lg-12">
                                <CustomSelect
                                    className="driver-type-select"
                                    classNamePrefix="driver-type-select-options"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={aggregatorList.find((element) => {
                                        return element.value?.id === aggregatorField?.value?.id;
                                    })}
                                    onChange={handleAggregatorSelect}
                                    placeholder="Select Aggregator"
                                    options={aggregatorList}
                                />
                                <span style={{ color: "red" }}>
                                    {errors?.aggregatorDropdown?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Service City</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={cityData.find((element) => {
                                            return element?.value?.id === serviceCityField?.value?.id;
                                        })}
                                        isDisabled={editId ? true : false}
                                        onChange={handleCitySelectChange}
                                        placeholder="Select City"
                                        options={cityData}
                                    />
                                </div>
                                <span style={{ color: "red" }}>{errors?.serviceCity?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Cab Type</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={carTypeData.find((element) => {
                                            return element?.value?.id === carTypeField?.value?.id;
                                        })}
                                        isDisabled={serviceCityField?.value?.id ? false : true}
                                        onChange={handleCarTypeSelectChange}
                                        placeholder={
                                            serviceCityField?.value?.id
                                                ? "Select Car Type"
                                                : "Select city to select car type"
                                        }
                                        options={carTypeData}
                                    />
                                </div>
                                <span style={{ color: "red" }}>
                                    {errors?.carTypeDropdown?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Procurement Status</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={procurementData.find((element) => {
                                            return element?.value === procurementStatusField?.value;
                                        })}
                                        onChange={(data)=>{
                                            procurementStatusField.onChange(data.value)
                                        }}
                                        placeholder={"Select Procurement Status"}
                                        options={procurementData}
                                    />
                                </div>
                                <span style={{ color: "red" }}>
                                    {errors?.procurementStatus?.message}
                                </span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isAvailable" type="checkbox" checked={isAvailableField.value}
                                    onChange={(value) => isAvailableField.onChange(value)} />
                                <Label className="mb-0" for="isAvailable">Is Available</Label>
                            </div>
                        </FormGroup>
                        {carTypeField.value?.id == 101 ? <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isEV" type="checkbox" checked={isEVField.value}
                                    onChange={(value) => {
                                        isEVField.onChange(value)
                                        fuelTypeDropdownField.onChange("");
                                    }} disabled={carTypeField.value?.id == 101 ? true : false} />
                                <Label className="mb-0" for="isEV">Is EV</Label>
                            </div>
                        </FormGroup> : ""}
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Fuel Type</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={fuelTypeDropdownField?.value?.id ? isEVField.value ? evFuelTypes.find((element) => {
                                            return element?.value?.id === fuelTypeDropdownField?.value?.id;
                                        }) : fuelTypes.find((element) => {
                                            return element?.value?.id === fuelTypeDropdownField?.value?.id;
                                        }) : ""}
                                        onChange={handleFuelTypeSelectChange}
                                        placeholder={
                                            "Select fuel type"
                                        }
                                        options={isEVField.value ? evFuelTypes : fuelTypes}
                                    />
                                </div>
                                <span style={{ color: "red" }}>
                                    {errors?.fuelTypeDropdown?.message}
                                </span>
                            </Col>
                        </FormGroup>
                    </Row>
                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            setTabName("Basic Information");
                            setIsAdvanced(false)
                            clearErrors()
                        }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button" onClick={async () => {
                            const result = await trigger(["aggregatorDropdown", "serviceCity", "carTypeDropdown", "fuelTypeDropdown", "procurementStatus"]);
                            console.log("result", result)
                            if (result) {
                                setTabName("Permit Information");
                                setIsAdvanced(false)
                                clearErrors()
                            }
                        }} >
                            Next
                        </button>
                    </Row>
                </> : tabName == "Permit Information" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Permit Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Permit No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("permitNo", {
                                        onChange: (e) => {
                                            setValue("permitNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Permit Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={permitExpDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => permitExpDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="toShowAllIndiaPermit" type="checkbox" checked={toShowAllIndiaPermitField.value}
                                    onChange={(value) => toShowAllIndiaPermitField.onChange(value)} />
                                <Label className="mb-0" for="toShowAllIndiaPermit">To Show All India Permit</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="toShowCCPermit" type="checkbox" checked={toShowCCPermitField.value}
                                    onChange={(value) => toShowCCPermitField.onChange(value)} />
                                <Label className="mb-0" for="toShowCCPermit">To Show CC Permit</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="toShowPUCPermit" type="checkbox" checked={toShowPUCPermitField.value}
                                    onChange={(value) => toShowPUCPermitField.onChange(value)} />
                                <Label className="mb-0" for="toShowPUCPermit">To Show PUC Permit</Label>
                            </div>
                        </FormGroup>
                        {
                            toShowAllIndiaPermitField.value ? (
                                <>
                                    <FormGroup className="col-lg-4">
                                        <Label className="col-lg-12 col-form-label">All India Permit No</Label>
                                        <Col lg="12">
                                            <input
                                                className="form-control"
                                                {...register("allIndiaPermitNo", {
                                                    onChange: (e) => {
                                                        setValue("allIndiaPermitNo", e.target.value.trimStart())
                                                    }
                                                })}
                                                type="text"
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="col-lg-4">
                                        <Label className="col-lg-12 col-form-label">All India Permit Expiry Date</Label>
                                        <Col lg="12">
                                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                                <DatePicker
                                                    showIcon
                                                    className="form-control"
                                                    selected={allIndiaPermitExpDateField.value}
                                                    dropdownMode="select"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    scrollableYearDropdown
                                                    onChange={(date) => allIndiaPermitExpDateField.onChange(date)}
                                                    dateFormat="MMMM d yyyy"
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </FormGroup>
                                </>
                            ) : null
                        }
                        {
                            toShowCCPermitField.value ? (
                                <>
                                    <FormGroup className="col-lg-4">
                                        <Label className="col-lg-12 col-form-label">CC Permit No</Label>
                                        <Col lg="12">
                                            <input
                                                className="form-control"
                                                {...register("ccPermitNo", {
                                                    onChange: (e) => {
                                                        setValue("ccPermitNo", e.target.value.trimStart())
                                                    }
                                                })}
                                                type="text"
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="col-lg-4">
                                        <Label className="col-lg-12 col-form-label">CC Permit Expiry Date</Label>
                                        <Col lg="12">
                                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                                <DatePicker
                                                    showIcon
                                                    className="form-control"
                                                    selected={ccPermitExpDateField.value}
                                                    dropdownMode="select"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    scrollableYearDropdown
                                                    onChange={(date) => ccPermitExpDateField.onChange(date)}
                                                    dateFormat="MMMM d yyyy"
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </FormGroup>
                                </>
                            ) : null
                        }
                        {
                            toShowPUCPermitField.value ? (
                                <>
                                    <FormGroup className="col-lg-4">
                                        <Label className="col-lg-12 col-form-label">PUC Permit No</Label>
                                        <Col lg="12">
                                            <input
                                                className="form-control"
                                                {...register("pucPermitNo", {
                                                    onChange: (e) => {
                                                        setValue("pucPermitNo", e.target.value.trimStart())
                                                    }
                                                })}
                                                type="text"
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="col-lg-4">
                                        <Label className="col-lg-12 col-form-label">PUC Permit Expiry Date</Label>
                                        <Col lg="12">
                                            <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                                <DatePicker
                                                    showIcon
                                                    className="form-control"
                                                    selected={pucPermitExpDateField.value}
                                                    dropdownMode="select"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    scrollableYearDropdown
                                                    onChange={(date) => pucPermitExpDateField.onChange(date)}
                                                    dateFormat="MMMM d yyyy"
                                                    onKeyDown={(e) => {
                                                        e.preventDefault();
                                                    }}
                                                />
                                            </InputGroup>
                                        </Col>
                                    </FormGroup>
                                </>
                            ) : null
                        }
                    </Row>
                    {/* <Row>
            <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
          </Row>
          {isAdvanced ? <Row>
            
          </Row> : null} */}


                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button"
                            onClick={async () => {
                                setTabName("Cab Information");
                                setIsAdvanced(false)
                                clearErrors()
                            }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button" onClick={async () => {

                            setTabName("Other Information");
                            setIsAdvanced(false)
                            clearErrors()
                        }} >
                            Next
                        </button>
                    </Row>
                </> : tabName == "Other Information" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>RC/Fitness/Tax Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">RC</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("rc", {
                                        onChange: (e) => {
                                            setValue("rc", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Fitness Permit No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("fitnessPermitNo", {
                                        onChange: (e) => {
                                            setValue("fitnessPermitNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Fitness Permit Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={fitnessPermitExpDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => fitnessPermitExpDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isOldUnit" type="checkbox" checked={isOldUnitField.value}
                                    onChange={(value) => isOldUnitField.onChange(value)} />
                                <Label className="mb-0" for="isOldUnit">Is Old Unit</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Road Tax Permit No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("roadTaxPermitNo", {
                                        onChange: (e) => {
                                            setValue("roadTaxPermitNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Road Tax Permit Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={roadTaxPermitExpDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => roadTaxPermitExpDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                    </Row>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Emission/Meter Passing Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Emission</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("emission", {
                                        onChange: (e) => {
                                            setValue("emission", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Emission Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={emissionExpDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => emissionExpDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Meter Passing</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("meterPassing", {
                                        onChange: (e) => {
                                            setValue("meterPassing", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Meter Passing Expiry Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={meterPassingExpDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => meterPassingExpDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                    </Row>
                    {/* <Row>
            <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
          </Row>
          {isAdvanced ? <Row>
            
          </Row> : null} */}


                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            setTabName("Permit Information");
                            setIsAdvanced(false)
                            clearErrors()
                        }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button"
                            onClick={async () => {
                                setTabName("Insurance Information");
                                setIsAdvanced(false)
                                clearErrors()
                            }}>
                            Next
                        </button>
                    </Row>
                </> : tabName == "Insurance Information" ? <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Insurance Information</div>
                    </Row>
                    <Row>
                        <FormGroup className="col-lg-4" style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                                <Input id="isInsured" type="checkbox" checked={isInsuredField.value}
                                    onChange={(value) => isInsuredField.onChange(value)} />
                                <Label className="mb-0" for="isInsured">Is Insured</Label>
                            </div>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Insurance Number</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("insuranceNumber", {
                                        onChange: (e) => {
                                            setValue("insuranceNumber", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Insurance Amount</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    pattern="[0-9.]+"
                                    {...register("insuranceAmt", {
                                        onChange: (e) => {
                                            setValue("insuranceAmt", e.target.value.replace(/[^0-9.]/g, ''))
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Insurance Start Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={insuranceStartDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => insuranceStartDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Insurance End Date</Label>
                            <Col lg="12">
                                <InputGroup className="date" id="dt-minimum" data-target-input="nearest">
                                    <DatePicker
                                        showIcon
                                        className="form-control"
                                        selected={insuranceEndDateField.value}
                                        dropdownMode="select"
                                        showMonthDropdown
                                        showYearDropdown
                                        scrollableYearDropdown
                                        onChange={(date) => insuranceEndDateField.onChange(date)}
                                        dateFormat="MMMM d yyyy"
                                        onKeyDown={(e) => {
                                            e.preventDefault();
                                        }}
                                    />
                                </InputGroup>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Insurance Company</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("insuranceCompany", {
                                        onChange: (e) => {
                                            setValue("insuranceCompany", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-4">
                            <Label className="col-lg-12 col-form-label">Insurance Contact No</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    {...register("insuranceContactNo", {
                                        onChange: (e) => {
                                            setValue("insuranceContactNo", e.target.value.trimStart())
                                        }
                                    })}
                                    type="text"
                                />
                            </Col>
                        </FormGroup>
                    </Row>
                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            setTabName("Other Information");
                            setIsAdvanced(false)
                            clearErrors()
                        }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button"
                            onClick={async () => {
                                setTabName("Document Upload");
                                setIsAdvanced(false)
                                clearErrors()
                            }}>
                            Next
                        </button>
                    </Row>
                </> : <>
                    <Row>
                        <div style={{ fontSize: "18px", fontWeight: "500" }}>Document Upload</div>
                    </Row>
                    <Row>
                        <div>Please upload the required documents</div>
                        <div className="d-inline-flex" style={{ margin: "20px 0px" }}>
                            <div className="btn btn-primary" style={{ display: "flex", alignItems: "center", justifyContent: "center" }} onClick={getFile}><PlusSquare style={{ marginRight: "10px" }} />AddNew</div>
                            <div style={{ height: '0px', width: '0px', overflow: 'hidden' }}>
                                <Input id="upfile" multiple type="file" onChange={(e) => onFileChange(e)} /></div>
                        </div>
                        <Table style={{ marginBottom: "20px" }} dark={mix_background_layout == "dark-only" ? true : false}>
                            <thead><tr></tr></thead>
                            <tbody>
                                {files && files.length ?
                                    [...files].map((file, i) => {
                                        return (
                                            <tr key={i} >
                                                <td></td>
                                                <td style={{color: mix_background_layout == "dark-only" ? "white" : null}}>
                                                    <H6 attrH6={{ className: 'task_title_0' }} >{file.name}</H6>
                                                </td>
                                                <td><a href="#javascript" onClick={() => deleteFile(i)}><Trash2 /></a></td>
                                                <td></td>
                                            </tr>
                                        );
                                    })
                                    : uploadedFiles.length == 0 ? <tr><td style={{color: mix_background_layout == "dark-only" ? "white" : null}}><div className="no-favourite"><span>{"No Files Uploaded"}</span></div></td></tr>
                                        : null
                                }
                                {uploadedFiles && uploadedFiles.length ?
                                    [...uploadedFiles].map((file, i) => {
                                        return (
                                            <tr key={i} >
                                                <td></td>
                                                <td style={{color: mix_background_layout == "dark-only" ? "white" : null}}>
                                                    <H6 attrH6={{ className: 'task_title_0' }} >{file.fileName}</H6>
                                                </td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        );
                                    })
                                    : null
                                }
                            </tbody>

                        </Table>
                    </Row>
                    <Row className="submit-driver">
                        <button className="btn btn-primary" type="button" onClick={() => {
                            setTabName("Insurance Information");
                            setIsAdvanced(false)
                            clearErrors()
                        }}>
                            Back
                        </button>
                        <button className="btn btn-primary" style={{ marginLeft: "20px" }} type="button" onClick={onFormSubmit} >
                            {editId ? "Update" : "Create"}
                        </button>
                    </Row></>}
            </Form>
        </CommonModal>
    );
};

export default CreateCar;
